var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2192 7.80383C11.2192 7.03796 10.5963 6.41513 9.83048 6.41513H9.13614V4.33209C9.13614 2.41777 7.57871 0.860352 5.6644 0.860352C3.75008 0.860352 2.19266 2.41777 2.19266 4.33209V6.41513H1.49831C0.732449 6.41513 0.109619 7.03796 0.109619 7.80383V13.3586C0.109619 14.1245 0.732449 14.7473 1.49831 14.7473H9.83048C10.5963 14.7473 11.2192 14.1245 11.2192 13.3586V7.80383ZM3.58136 4.33209C3.58136 3.18364 4.51595 2.24905 5.6644 2.24905C6.81285 2.24905 7.74744 3.18364 7.74744 4.33209V6.41513H3.58136V4.33209Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.9ac7af26c694d21569de738c216b2455.svg";
export { ForwardRef as ReactComponent };